import { cn } from '@data-delivery/d3s';
import { Link } from 'react-router-dom';

export function BrandLogo({
  logoClassName,
  textClassName,
  className,
  text,
  url = '/',
}: {
  text?: string;
  logoClassName?: string;
  textClassName?: string;
  url?: string;
} & React.HTMLAttributes<HTMLElement>) {
  return (
    <Link to={url}>
      <div className={cn('relative z-20 flex items-center', className)}>
        <svg className={logoClassName} version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' viewBox='0 0 137.134 29.766'>
          <g>
            <defs>
              <rect id='SVGID_1_' width='137.134' height='29.766' />
            </defs>
            <clipPath id='SVGID_2_'>
              <use overflow='visible' />
            </clipPath>
            <path
              fill='#d6002a'
              d='M15.623,23.451c0,0.916-0.151,1.702-0.453,2.361
		c-0.302,0.659-0.691,1.227-1.167,1.703c-0.75,0.75-1.661,1.286-2.732,1.605c-1.071,0.32-2.21,0.48-3.418,0.48
		c-1.044,0-2.073-0.151-3.089-0.453s-1.927-0.819-2.732-1.551c-0.586-0.531-1.071-1.186-1.455-1.963C0.192,24.856,0,24,0,23.067
		h3.625c0,0.477,0.095,0.92,0.288,1.331c0.192,0.412,0.434,0.765,0.728,1.057c0.42,0.423,0.928,0.7,1.523,0.839
		c0.595,0.137,1.176,0.205,1.744,0.205c0.677,0,1.318-0.077,1.922-0.233c0.604-0.155,1.089-0.425,1.455-0.811
		c0.22-0.236,0.402-0.488,0.549-0.755c0.147-0.265,0.219-0.635,0.219-1.111c0-0.713-0.232-1.249-0.699-1.606
		c-0.467-0.356-1.002-0.59-1.607-0.7c-0.659-0.128-1.382-0.22-2.169-0.274S6.077,20.87,5.437,20.76
		c-0.678-0.11-1.314-0.302-1.908-0.576c-0.595-0.275-1.117-0.636-1.566-1.085c-0.448-0.448-0.805-0.988-1.07-1.62
		c-0.266-0.631-0.399-1.349-0.399-2.155c0-0.769,0.156-1.473,0.467-2.114s0.723-1.217,1.236-1.73c0.64-0.641,1.464-1.144,2.471-1.51
		c1.007-0.366,2.087-0.549,3.24-0.549c1.043,0,2.045,0.16,3.006,0.48c0.961,0.321,1.772,0.792,2.43,1.414
		c0.586,0.549,1.057,1.172,1.414,1.867c0.357,0.696,0.544,1.455,0.563,2.279h-3.624c-0.019-0.347-0.106-0.691-0.261-1.029
		c-0.156-0.339-0.353-0.636-0.59-0.893c-0.312-0.329-0.751-0.585-1.318-0.769c-0.568-0.182-1.117-0.274-1.648-0.274
		c-0.549,0-1.112,0.073-1.688,0.219c-0.577,0.147-1.067,0.431-1.469,0.852c-0.202,0.219-0.362,0.457-0.481,0.714
		c-0.119,0.256-0.178,0.567-0.178,0.933c0,0.641,0.183,1.13,0.549,1.469c0.366,0.339,0.842,0.554,1.428,0.645
		c0.622,0.093,1.322,0.175,2.1,0.247c0.778,0.074,1.487,0.156,2.128,0.247c0.732,0.11,1.423,0.308,2.073,0.591
		c0.65,0.284,1.217,0.659,1.703,1.125c0.484,0.468,0.869,1.03,1.153,1.689C15.48,21.886,15.623,22.627,15.623,23.451'
            />
            <path
              fill='#d6002a'
              d='M30.951,29.272l-1.372-1.538c-0.788,0.696-1.653,1.208-2.595,1.538
		c-0.943,0.329-1.918,0.494-2.925,0.494c-0.86,0-1.684-0.137-2.471-0.412c-0.787-0.273-1.473-0.663-2.059-1.167
		c-0.585-0.503-1.052-1.121-1.4-1.853c-0.348-0.732-0.522-1.557-0.522-2.472c0-1.208,0.316-2.241,0.948-3.103
		c0.631-0.86,1.469-1.61,2.512-2.251c-0.312-0.33-0.595-0.654-0.851-0.976c-0.257-0.319-0.476-0.645-0.659-0.975
		c-0.184-0.329-0.325-0.677-0.426-1.043c-0.1-0.366-0.151-0.778-0.151-1.235c0-0.769,0.142-1.456,0.426-2.06
		c0.283-0.604,0.663-1.121,1.139-1.551c0.476-0.43,1.039-0.755,1.689-0.975c0.649-0.219,1.34-0.329,2.073-0.329
		c0.714,0,1.395,0.105,2.045,0.316c0.65,0.21,1.222,0.521,1.717,0.933c0.494,0.412,0.887,0.916,1.18,1.51
		c0.293,0.595,0.44,1.277,0.44,2.046c0,0.641-0.092,1.212-0.276,1.716c-0.182,0.503-0.439,0.961-0.768,1.373
		c-0.329,0.411-0.719,0.791-1.167,1.139c-0.449,0.349-0.938,0.677-1.469,0.988l3.377,3.68c0.165-0.311,0.279-0.673,0.343-1.085
		s0.114-0.846,0.151-1.304c0.037-0.439,0.056-0.869,0.056-1.291V18.29h5.024v2.718h-2.251c-0.038,0.769-0.138,1.528-0.302,2.278
		c-0.165,0.752-0.458,1.446-0.879,2.088l3.596,3.898H30.951z M23.071,20.65c-0.329,0.202-0.631,0.395-0.906,0.577
		c-0.274,0.183-0.518,0.395-0.728,0.632c-0.21,0.238-0.375,0.507-0.494,0.81c-0.119,0.303-0.178,0.654-0.178,1.058
		c0,0.494,0.096,0.933,0.288,1.318c0.193,0.384,0.449,0.704,0.769,0.961c0.32,0.256,0.69,0.447,1.112,0.576
		c0.421,0.128,0.86,0.191,1.318,0.191c0.585,0,1.171-0.082,1.757-0.247s1.089-0.484,1.51-0.961L23.071,20.65z M26.476,14.308
		c0-0.677-0.206-1.199-0.618-1.565c-0.411-0.366-0.929-0.549-1.551-0.549c-0.567,0-1.071,0.169-1.51,0.508
		c-0.439,0.339-0.659,0.847-0.659,1.524c0,0.311,0.059,0.604,0.178,0.878c0.119,0.275,0.265,0.536,0.44,0.783
		c0.173,0.247,0.37,0.479,0.59,0.7c0.219,0.219,0.43,0.43,0.632,0.631c0.292-0.164,0.589-0.334,0.892-0.508
		c0.301-0.173,0.571-0.37,0.809-0.591c0.238-0.22,0.43-0.476,0.577-0.769C26.403,15.059,26.476,14.711,26.476,14.308'
            />
            <path
              fill='#d6002a'
              d='M52.211,16.01c0,0.934-0.146,1.784-0.439,2.554
		c-0.293,0.769-0.728,1.428-1.305,1.977c-0.576,0.549-1.294,0.976-2.155,1.277c-0.86,0.302-1.849,0.453-2.965,0.453h-4.118v6.974
		h-3.515V9.778h7.633c1.116,0,2.105,0.151,2.965,0.453c0.861,0.302,1.579,0.723,2.155,1.263c0.577,0.54,1.012,1.194,1.305,1.963
		S52.211,15.077,52.211,16.01 M48.643,16.038c0-0.934-0.275-1.693-0.824-2.279c-0.549-0.585-1.419-0.878-2.608-0.878h-3.981v6.287
		h3.981c1.189,0,2.059-0.288,2.608-0.865C48.367,17.727,48.643,16.972,48.643,16.038'
            />
            <path
              fill='#d6002a'
              d='M73.078,29.245l-0.412-2.143c-0.146,0.275-0.366,0.563-0.658,0.865
		c-0.294,0.302-0.654,0.573-1.085,0.811s-0.911,0.435-1.441,0.591c-0.53,0.154-1.099,0.232-1.702,0.232
		c-1.135,0-2.193-0.155-3.171-0.467c-0.98-0.311-1.854-0.878-2.622-1.702c-0.513-0.53-0.93-1.089-1.249-1.675
		c-0.321-0.586-0.577-1.208-0.769-1.867c-0.193-0.659-0.325-1.35-0.399-2.072c-0.073-0.724-0.109-1.487-0.109-2.294
		c0-0.785,0.031-1.54,0.096-2.265c0.064-0.723,0.188-1.404,0.37-2.045c0.183-0.641,0.44-1.254,0.769-1.84
		c0.33-0.585,0.759-1.144,1.291-1.675c0.75-0.75,1.642-1.318,2.676-1.702c1.034-0.385,2.074-0.577,3.117-0.577
		c1.208,0,2.306,0.202,3.295,0.604c0.988,0.403,1.812,0.943,2.471,1.62c0.477,0.495,0.878,1.057,1.208,1.689
		c0.329,0.631,0.522,1.378,0.576,2.238h-3.624c-0.037-0.385-0.137-0.714-0.302-0.989c-0.165-0.274-0.347-0.539-0.549-0.796
		c-0.678-0.787-1.712-1.181-3.104-1.181c-0.567,0-1.144,0.115-1.729,0.344c-0.586,0.229-1.071,0.553-1.455,0.974
		c-0.33,0.348-0.595,0.751-0.797,1.208c-0.201,0.458-0.357,0.939-0.466,1.442c-0.11,0.504-0.179,1.011-0.206,1.523
		c-0.028,0.513-0.041,0.988-0.041,1.427c0,0.44,0.017,0.921,0.054,1.442c0.037,0.522,0.11,1.039,0.22,1.551
		c0.11,0.514,0.265,1.002,0.467,1.47c0.201,0.467,0.466,0.874,0.796,1.222c0.384,0.421,0.865,0.731,1.442,0.933
		c0.576,0.202,1.148,0.303,1.715,0.303c0.642,0,1.204-0.101,1.689-0.303c0.484-0.201,0.892-0.475,1.222-0.822
		c0.531-0.55,0.874-1.131,1.03-1.744c0.155-0.613,0.232-1.295,0.232-2.045h-4.64v-2.938h8.072v10.653H73.078z'
            />
            <path
              fill='#d6002a'
              d='M83.948,29.217c-0.349,0.072-0.601,0.124-0.755,0.15
		c-0.155,0.028-0.407,0.041-0.755,0.041c-1.172,0-2.114-0.302-2.828-0.906c-0.714-0.604-1.071-1.583-1.071-2.938V9.393h3.46v15.596
		c0,0.421,0.082,0.755,0.247,1.002s0.54,0.371,1.126,0.371c0.146,0,0.256-0.005,0.329-0.014s0.155-0.015,0.247-0.015V29.217z'
            />
            <path
              fill='#d6002a'
              d='M98.517,22.106c0,1.208-0.147,2.22-0.439,3.034
		c-0.293,0.814-0.705,1.561-1.236,2.237c-0.493,0.604-1.176,1.125-2.045,1.565c-0.87,0.438-1.854,0.659-2.952,0.659
		s-2.082-0.221-2.95-0.659c-0.87-0.44-1.553-0.961-2.046-1.565c-0.531-0.677-0.943-1.423-1.236-2.237
		c-0.292-0.814-0.439-1.826-0.439-3.034s0.147-2.22,0.439-3.034c0.293-0.814,0.705-1.561,1.236-2.238
		c0.493-0.604,1.176-1.125,2.046-1.565c0.868-0.439,1.852-0.659,2.95-0.659s2.082,0.22,2.952,0.659
		c0.869,0.44,1.552,0.961,2.045,1.565c0.531,0.678,0.943,1.424,1.236,2.238C98.369,19.886,98.517,20.898,98.517,22.106
		 M95.029,22.106c0-0.677-0.064-1.332-0.192-1.963c-0.129-0.633-0.402-1.177-0.823-1.635c-0.238-0.256-0.54-0.471-0.906-0.645
		s-0.787-0.261-1.264-0.261c-0.476,0-0.896,0.087-1.263,0.261s-0.669,0.389-0.906,0.645c-0.421,0.458-0.695,1.002-0.823,1.635
		c-0.128,0.631-0.192,1.286-0.192,1.963s0.064,1.332,0.192,1.963c0.128,0.632,0.402,1.177,0.823,1.634
		c0.237,0.256,0.54,0.471,0.906,0.646c0.366,0.174,0.787,0.261,1.263,0.261c0.477,0,0.897-0.087,1.264-0.261
		c0.366-0.175,0.668-0.39,0.906-0.646c0.421-0.457,0.694-1.002,0.823-1.634C94.965,23.438,95.029,22.783,95.029,22.106'
            />
            <path
              fill='#d6002a'
              d='M114.354,22.133c0,1.354-0.211,2.558-0.633,3.61
		c-0.421,1.053-1.061,1.927-1.922,2.623c-0.438,0.365-0.946,0.658-1.522,0.878c-0.577,0.22-1.223,0.329-1.937,0.329
		c-0.787,0-1.547-0.15-2.278-0.452c-0.732-0.303-1.31-0.783-1.73-1.442l-0.22,1.565h-2.964V9.42h3.431v6.59
		c0.33-0.402,0.82-0.736,1.469-1.002c0.65-0.265,1.405-0.398,2.266-0.398c0.731,0,1.387,0.101,1.964,0.302
		c0.576,0.201,1.084,0.485,1.522,0.851C113.502,17.173,114.354,19.296,114.354,22.133 M110.866,22.079
		c0-0.622-0.061-1.236-0.179-1.841c-0.119-0.604-0.361-1.143-0.728-1.618c-0.257-0.313-0.573-0.577-0.947-0.798
		c-0.376-0.219-0.828-0.328-1.359-0.328c-0.677,0-1.227,0.142-1.647,0.425c-0.421,0.284-0.751,0.649-0.987,1.099
		c-0.238,0.448-0.399,0.943-0.481,1.482c-0.082,0.54-0.123,1.066-0.123,1.579c0,0.695,0.082,1.404,0.247,2.128
		c0.164,0.723,0.494,1.313,0.988,1.771c0.237,0.22,0.521,0.395,0.852,0.522c0.329,0.128,0.713,0.191,1.152,0.191
		c0.531,0,0.983-0.109,1.359-0.33c0.374-0.219,0.69-0.484,0.947-0.796c0.366-0.476,0.608-1.02,0.728-1.634
		C110.806,23.318,110.866,22.702,110.866,22.079'
            />
            <path
              fill='#d6002a'
              d='M129.591,29.08c-0.293,0.129-0.545,0.225-0.755,0.288
		c-0.21,0.064-0.525,0.097-0.946,0.097c-0.751,0-1.327-0.202-1.73-0.604c-0.403-0.401-0.631-0.869-0.686-1.399
		c-0.33,0.586-0.879,1.089-1.648,1.51c-0.769,0.421-1.665,0.631-2.689,0.631c-0.861,0-1.612-0.123-2.253-0.37
		s-1.176-0.577-1.606-0.989c-0.429-0.412-0.755-0.887-0.974-1.427c-0.22-0.54-0.329-1.103-0.329-1.688
		c0-0.678,0.123-1.281,0.37-1.813c0.246-0.531,0.591-0.989,1.029-1.373c0.439-0.384,0.952-0.682,1.538-0.892
		c0.585-0.211,1.216-0.345,1.895-0.399l4.2-0.302V19.47c0-0.677-0.16-1.223-0.48-1.634c-0.32-0.412-0.965-0.618-1.937-0.618
		c-0.805,0-1.431,0.175-1.88,0.521c-0.448,0.349-0.69,0.852-0.728,1.511h-3.322c0.055-0.806,0.242-1.502,0.563-2.087
		c0.319-0.586,0.746-1.066,1.275-1.441c0.531-0.375,1.145-0.654,1.84-0.837c0.696-0.183,1.446-0.275,2.251-0.275
		c1.228,0,2.321,0.215,3.282,0.645c0.96,0.431,1.652,1.186,2.072,2.265c0.183,0.458,0.298,0.934,0.344,1.428
		c0.045,0.494,0.069,0.98,0.069,1.455v5.3c0,0.329,0.059,0.563,0.178,0.7c0.119,0.137,0.325,0.206,0.618,0.206
		c0.146,0,0.247-0.009,0.302-0.028c0.056,0,0.101-0.009,0.137-0.026V29.08z M125.006,22.902l-3.624,0.274
		c-0.53,0.037-1.007,0.211-1.428,0.521c-0.422,0.313-0.632,0.761-0.632,1.347c0,0.549,0.206,0.983,0.618,1.304
		s0.883,0.479,1.414,0.479c1.08,0,1.959-0.278,2.636-0.837c0.677-0.558,1.016-1.368,1.016-2.43V22.902z'
            />
            <path
              fill='#d6002a'
              d='M137.134,29.217c-0.348,0.072-0.6,0.124-0.755,0.15
		c-0.156,0.028-0.408,0.041-0.755,0.041c-1.172,0-2.114-0.302-2.828-0.906c-0.714-0.604-1.071-1.583-1.071-2.938V9.393h3.459v15.596
		c0,0.421,0.083,0.755,0.248,1.002s0.539,0.371,1.125,0.371c0.147,0,0.256-0.005,0.33-0.014c0.073-0.009,0.155-0.015,0.247-0.015
		V29.217z'
            />
            <rect width='137.134' fill='currentColor' height='3.16' />
          </g>
        </svg>
        {text && (
          <p className={cn('mb-0 relative ml-4 pl-3 before:content-[""] before:absolute before:top-0 before:left-0 before:w-[1px] before:bg-foreground before:h-full', textClassName)}>{text}</p>
        )}
      </div>
    </Link>
  );
}
